import React, {useContext, useState}from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonContent, IonButton, IonImg, IonFooter, IonHeader } from '@ionic/react';
import { Document, Page } from 'react-pdf';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';


import '../../css/layout.css';


export function ViewInvoiceModal(props) {

    let authenticatedMerchent_context = useContext(Auth_Zasava_Context);

    const [fileLocation, setFileLocation ] = useState(null);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    function closeModalHandler() {

        props.closeModal(false);
    }

    async function openPDF(){
        //window.open(props.data.fileLocation);

        const uriResult = await Filesystem.getUri({
            directory: Directory.Data,
            path: props.data.fileLocation,
          });
    
          // the path to the file
          const path = uriResult.uri;
    
          // convert to capacitor//
          const localFileURL = Capacitor.convertFileSrc(path);

          setFileLocation(localFileURL);

    }

    function openBroswer(){
        //window.open(props.data.fileLocation);
        //alert( "baseURL+props.data.fileLocation");

        //alert( baseURL+props.data.fileLocation);

        Browser.open({ url: baseURL+props.data.fileLocation}).then(() => {});

    }

    return (
    <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonGrid >
                <IonRow>
                    <IonCol> ID</IonCol>
                </IonRow>
                <IonRow>
                    <IonCol> {props.data.applicationID} </IonCol>
                </IonRow>
            </IonGrid >
            <IonGrid >
                <IonRow>
                    <IonCol>
                        <IonButton onClick={openBroswer}>Open PDF</IonButton>
                        {/*<IonButton href={props.data.fileLocation}>View Invoice</IonButton>
                        <IonButton href={baseURL+'fileServer/merchants/bluefin_6569/forms/temp/'+props.data.fileLocation}>View Invoice Href</IonButton>
                        <object data={props.data.fileLocation} type="application/pdf" width='100%' height='100%'>
                            <p>Alternative text - include a link <a href={props.data.fileLocation}>to the PDF!</a></p>
                        </object>
                        <Document file={props.data.fileLocation}>
                            <Page pageNumber='1'></Page>
                        </Document>

                                <iframe
                                    width='100%'
                                    height='100%'
                                    src={props.data.fileLocation}
                                >
                                </iframe>*/}
                    </IonCol>
                </IonRow>
            </IonGrid>
            <IonFooter className='modal_footer_button_center'>
                <IonButton onClick={closeModalHandler}> Close </IonButton>
            </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}